module.exports = __webpack_public_path__ + "static/img/RAPS-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS-G_1.png
// module id = D72M
// module chunks = 0